export default {"src":"/asasqt-service-app//_next/static/media/favicon.996c48d6.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};